@if (formRef) {
  <div [formGroup]="formRef" class="mt-6">
    <p id="preferred-contact-label" class="comcast-input-label">
      Preferred method of contact
    </p>

    <mat-radio-group
      class="flex flex-col"
      formControlName="preferredContactMethod"
      aria-labelledby="preferred-contact-label"
      (change)="onRadioChange()"
    >
      @if (reporter.Email) {
        <mat-radio-button value="email">
          <div class="flex items-center gap-1">
            <mat-icon
              class="!flex !h-5 !w-5 !items-center !justify-center !text-xl"
              aria-hidden="true"
              >email</mat-icon
            >
            <span class="font-lato text-base text-black">{{
              reporter.Email
            }}</span>
          </div>
        </mat-radio-button>
      }

      @if (reporter.Phone) {
        <mat-radio-button value="phone">
          <div class="flex items-center gap-1">
            <mat-icon
              class="!flex !h-5 !w-5 !items-center !justify-center !text-xl"
              aria-hidden="true"
              >phone</mat-icon
            >
            <span class="font-lato text-base text-black">
              {{ reporter.Phone | phoneNumber: 'US' }}
            </span>
          </div>
        </mat-radio-button>
      }

      @if (altContact) {
        <mat-radio-button #alternatePhoneRadioButton value="Alternate Phone">
          <div class="flex w-full flex-row items-center gap-1">
            <mat-icon
              class="!flex !h-5 !w-5 !shrink-0 !items-center !justify-center !text-xl md:!h-11"
              aria-hidden="true"
            >
              phone
            </mat-icon>
            <div class="relative w-full">
              <button
                type="button"
                class="comcast-select-trigger"
                [class.comcast-select-trigger--open]="isCountryDropdownOpen"
                [class.comcast-select-trigger--filled]="!!selectedCountryLabel"
                [class.comcast-input-invalid]="inlineErrors.countryCode"
                aria-label="Country code (required)"
                [attr.aria-expanded]="isCountryDropdownOpen"
                aria-haspopup="listbox"
                aria-controls="country-listbox"
                aria-required="true"
                [attr.aria-invalid]="!!inlineErrors.countryCode"
                [attr.aria-describedby]="
                  alternatePhoneErrorMessage ? 'alt-phone-error' : null
                "
                (click)="toggleCountryDropdown($event)"
              >
                <span
                  [class.text-brand-muted]="!selectedCountryLabel"
                  [class.text-black]="selectedCountryLabel"
                >
                  {{ selectedCountryLabel || 'Country*' }}
                </span>
                <mat-icon
                  class="text-brand-text !flex !h-5 !w-5 !items-center !justify-center !text-xl"
                  aria-hidden="true"
                >
                  {{
                    isCountryDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down'
                  }}
                </mat-icon>
              </button>

              @if (isCountryDropdownOpen) {
                <!-- a11y listbox pattern: docs/accessibility/custom-listbox.md -->
                <div
                  id="country-listbox"
                  class="comcast-select-panel comcast-select-panel--open"
                  role="listbox"
                  aria-label="Country codes"
                  [class.comcast-select-panel--invalid]="
                    inlineErrors.countryCode
                  "
                  (click)="$event.stopPropagation()"
                >
                  <div class="comcast-select-search">
                    <mat-icon
                      class="text-brand-muted !flex !h-5 !w-5 !items-center !justify-center !text-xl"
                      aria-hidden="true"
                    >
                      search
                    </mat-icon>
                    <input
                      type="text"
                      placeholder="Search"
                      aria-label="Search country codes"
                      [value]="countrySearchTerm"
                      (input)="onCountrySearchInput($event)"
                      class="comcast-select-search-input"
                      appAutofocus
                    />
                  </div>
                  <div class="comcast-select-options">
                    @for (country of filteredCountryCodes; track country.iso2) {
                      <div
                        class="comcast-select-option"
                        role="option"
                        tabindex="0"
                        [attr.aria-selected]="
                          formRef.value.countryCode ===
                          country.iso2.toUpperCase()
                        "
                        [class.comcast-select-option--selected]="
                          formRef.value.countryCode ===
                          country.iso2.toUpperCase()
                        "
                        (click)="selectCountry(country, $event)"
                        (keydown.enter)="selectCountry(country, $event)"
                        (keydown.space)="selectCountry(country, $event)"
                      >
                        {{ country.name }}
                      </div>
                    }
                    @if (!filteredCountryCodes.length) {
                      <div
                        class="text-brand-muted font-lato px-4 py-3 text-sm"
                        role="option"
                        aria-disabled="true"
                      >
                        No results found
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <input
              type="tel"
              formControlName="alternatePhone"
              id="alternatePhone"
              class="comcast-input !mt-0"
              [ngClass]="{
                'comcast-input-invalid': inlineErrors.alternatePhone,
              }"
              placeholder="Alternate phone number"
              aria-label="Alternate phone number"
              [attr.aria-invalid]="!!inlineErrors.alternatePhone"
              [attr.aria-describedby]="
                alternatePhoneErrorMessage ? 'alt-phone-error' : null
              "
              (click)="selectAlternatePhoneRadioButton()"
              (blur)="formatAlternatePhone()"
              (keypress)="altPhoneKeypress($event)"
            />
          </div>
        </mat-radio-button>
      }
    </mat-radio-group>

    @if (alternatePhoneErrorMessage) {
      <div
        id="alt-phone-error"
        class="comcast-validation-error mt-2"
        role="alert"
      >
        {{ alternatePhoneErrorMessage }}
      </div>
    }
  </div>
}
